var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[(_vm.isEmpty)?_c('Empty',{staticClass:"empty",attrs:{"tips":"没有数据"}}):_vm._e(),_c('div',{ref:"chart",staticStyle:{"height":"500px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }